<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="list-wrapper">
    <div class="buttons">
        <button id="add-folder-button" color="primary" mat-raised-button (click)="addPath()" [disabled]="disabled"
                [disableRipple]="true" aria-label="Add Path"><i
                class="mdi mdi-plus-box-outline"></i> {{ 'PATH_LIST_TITLE' | translate }}
        </button>
    </div>
    <mat-list class="path-list">
        <mat-list-item *ngFor="let path of paths; let i = index;trackBy:trackByIdx;" lines="3.5">
            <span matListItemLine>
                <mat-form-field class="new-path-input" appearance="outline">
                    <mat-label>{{'SAFE_APP_PATH' | translate}}</mat-label>
                    <input matInput name="name{{i}}" type="text" (keyup)="isDupePath($event, i)" [(ngModel)]="paths[i]"
                           (keydown)="changed.emit()" required #pathInput [readonly]="disabled" aria-label="Path">
                    <mat-error>{{ 'PATH_REQUIRED' | translate }}</mat-error>
                </mat-form-field> <span class="remove-row-icon delete-icon">
                    <button mat-icon-button (click)="deletePath(i)" *ngIf="!disabled"
                            matTooltip="{{'DELETE_PATH' | translate}}" matTooltipShowDelay="350"
                            matTooltipPosition="right"
                            aria-label="Delete Path">
                        <span class="mdi mdi-close-circle-outline"></span>
                    </button>
                </span>
            </span>
        </mat-list-item>
    </mat-list>
</div>
